export const productSkuOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    // menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "SKU名称",
            prop: "skuName",
            type: "input"
        },
        {
            label: '产品一级分类',
            prop: 'firstClassifyName',
            formsolt: true
        }
        ,{
            label: '产品二级分类',
            prop: 'secondClassifyName',
            formsolt: true
        },
        {
            label: "SKU组合",
            prop: "constitute",
            span: 24,
            solt: true,
            hide: true,
            formsolt: true
        }



    ]
};